const DS_STORE = ".DS_Store";
export default DS_STORE;
